import * as Ajax from '../ajax/Ajax';
import "../models/usergroup/UserGroupResultModel";
/**
 * 一覧を取得します。
 *
 * @param fn ファンクション
 */

export function Query(searchWord, startRow, pageSize, fn) {
  Ajax.Post("UserGroupApi/Query", {
    searchWord: searchWord,
    startRow: startRow,
    pageSize: pageSize
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーグループを追加します。
 *
 * @param groupName グループ名
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function AddGroup(groupName, fn) {
  Ajax.Post("UserGroupApi/AddGroup", {
    name: groupName
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーグループを更新します。
 *
 * @param groupId グループＩＤ
 * @param groupName グループ名
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyGroup(groupId, groupName, organizationId, updateDateTime, fn) {
  Ajax.Post("UserGroupApi/ModifyGroup", {
    id: groupId,
    name: groupName,
    organizationId: organizationId,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーグループを削除します。
 *
 * @param groupId ユーザーグループＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteGroup(groupId, updateDateTime, fn) {
  Ajax.Post("UserGroupApi/DeleteGroup", {
    id: groupId,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 現在のグループメンバーと、選択可能メンバーを取得します。
 *
 * @param fn ファンクション
 */

export function GetGroupMemberList(groupId, fn) {
  Ajax.Post("UserGroupApi/GetGroupMemberList", {
    groupId: groupId
  }, Ajax.ModelResult(fn));
}
/**
 * 絞り込みグループ一覧検索を行います。
 *
 * @param fn ファンクション
 */

export function QueryUserGroupNarrowdownList(fn) {
  Ajax.Post("UserGroupApi/QueryUserGroupNarrowdownList", {}, Ajax.ModelResult(fn));
}
/**
 * ユーザーグループメンバーを更新します。
 *
 * @param groupId ユーザーグループＩＤ
 * @param targetUserIdList ユーザーＩＤリスト
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyMember(groupId, targetUserIdList, updateDateTime, fn) {
  Ajax.Post("UserGroupApi/ModifyMember", {
    groupId: groupId,
    targetUserIdList: targetUserIdList,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}